import { useAuthenticationContext } from "@dbn/omnichannel-design-system-g4p";
import { useEffect } from "react";
import { OpenLoanApplicationForRemoteSigning } from "./OpenLoanApplicationForRemoteSigning";

export const OpenLoanApplicationForRemoteSigningWrapper = () => {
  const { transitionToPotentialClient } = useAuthenticationContext();

  useEffect(() => {
    transitionToPotentialClient();
  }, []);

  return <OpenLoanApplicationForRemoteSigning />;
};
